import { RESET_ERROR } from '../../constants';
import { ErrorResetAction } from './errors.types';
import { ActionCreator } from 'redux';

export const resetError: ActionCreator<ErrorResetAction> = (requestNames: string[]) => ({ type: RESET_ERROR, requestNames });
